import { useEffect, useState } from "react";
import axios from "../api/client";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

// Read this once before React development Strict Mode mounts the component twice.
const resetTokenFromLocation = typeof window === "undefined" ? "" : window.location.hash.slice(1);

export default function PasswordResetPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [token] = useState(resetTokenFromLocation);
  const [password, setPassword] = useState("");
  const [confirmation, setConfirmation] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (resetTokenFromLocation) window.history.replaceState(null, "", window.location.pathname);
  }, []);

  async function submit(event) {
    event.preventDefault();
    setError("");
    setMessage("");
    setSubmitting(true);
    try {
      const result = await axios.post("/api/password-reset/confirm", {
        token, password, passwordConfirmation: confirmation,
      }, { withCsrf: false });
      setMessage(result.data.message);
      setTimeout(() => navigate("/login", { replace: true }), 1200);
    } catch {
      setError(t("passwordReset.errors.confirm"));
    } finally {
      setSubmitting(false);
    }
  }

  return <div className="max-w-md mx-auto bg-white border rounded-xl shadow p-6 mt-10">
    <h1 className="text-2xl font-semibold mb-4 text-center">{t("passwordReset.title")}</h1>
    {!token ? <p className="text-red-600">{t("passwordReset.errors.missing")}</p> : <form onSubmit={submit} className="space-y-4">
      <label className="block text-sm font-medium text-gray-600">{t("passwordReset.newPassword")}
        <input type="password" minLength="12" value={password} onChange={(event) => setPassword(event.target.value)} autoComplete="new-password" required className="w-full border rounded-lg px-3 py-2 mt-1" />
      </label>
      <label className="block text-sm font-medium text-gray-600">{t("passwordReset.confirmPassword")}
        <input type="password" minLength="12" value={confirmation} onChange={(event) => setConfirmation(event.target.value)} autoComplete="new-password" required className="w-full border rounded-lg px-3 py-2 mt-1" />
      </label>
      {error && <p className="text-red-600 text-sm" role="alert">{error}</p>}
      {message && <p className="text-green-700 text-sm">{message}</p>}
      <button type="submit" disabled={submitting} className="w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 disabled:opacity-60">{t("passwordReset.submit")}</button>
    </form>}
  </div>;
}
